import React from "react";
import { Range, getTrackBackground } from 'react-range';
import { useTranslation } from 'react-i18next'


export default function RangeExt({max, states, value}) {

    const [rangeVal, setRangeVal] = React.useState(0);
    const { t, i18n } = useTranslation();
    
    const rangeHandle = (v)=>{
        setRangeVal(v[0]);
        value(states[v[0]].value);
    }

    React.useEffect(()=>{
        value(states[0].value)
    }, [])

    return (
        <>
        <Range
            rtl={i18n.language == 'fa' || i18n.language == 'ar' ? true : false }
            min={0}
            max={max -1}
            values={[rangeVal]}
            onChange={rangeHandle}
            renderTrack={({ props, children }) => (
                <div
                    {...props}
                    style={{
                        ...props.style,
                        height: '10px',
                        width: '100%',
                        backgroundColor: "#eee"
                    }}
                >
                    {children}
                </div>
            )}

            renderThumb={({ props }) => (
                <div
                    {...props}
                    style={{
                        ...props.style,
                        height: '20px',
                        width: '20px',
                        borderRadius: '20px',
                        backgroundColor: '#2E71FC'
                    }}
                />
            )}

        />
        <div className="range-caption">{states[rangeVal].name}</div>
        </>
    )
}